/**
 * Helpers for the block-level inline style carried by ExtendedParagraphNode /
 * ExtendedHeadingNode. These nodes store a small CSS string (currently used for
 * paragraph spacing: margin-top / margin-bottom) that core Lexical element nodes
 * don't support. Styling is applied per-property so it never clobbers the
 * text-align / indent that Lexical's reconciler writes to the same element.
 */

export function getBlockStyleObject(css) {
    const obj = {};
    if (!css) return obj;
    for (const decl of css.split(';')) {
        const idx = decl.indexOf(':');
        if (idx === -1) continue;
        const prop = decl.slice(0, idx).trim();
        const val = decl.slice(idx + 1).trim();
        if (prop) obj[prop] = val;
    }
    return obj;
}

export function blockStyleToCss(obj) {
    return Object.entries(obj)
        .filter(([, v]) => v !== '' && v != null)
        .map(([k, v]) => `${k}: ${v}`)
        .join('; ');
}

// Diff prev/next CSS strings and apply only the changed properties to the DOM
// node, removing any property that's no longer present.
export function applyBlockStyle(dom, prevCss, nextCss) {
    const prev = getBlockStyleObject(prevCss);
    const next = getBlockStyleObject(nextCss);
    for (const prop of Object.keys(prev)) {
        if (!(prop in next)) dom.style.removeProperty(prop);
    }
    for (const [prop, val] of Object.entries(next)) {
        dom.style.setProperty(prop, val);
    }
}
